// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"styles_inputContainer__204Ja","inputLabel":"styles_inputLabel__1qiBE"};